export { default } from "./SkeletonPlaceholderContainer";
